import React from "react";

import { SS23 } from "../../../../js/database/database-ss23.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const ChainlockLeatherBikerPants = () => {
  return (
    <ProductsContainer
      pageTitle={SS23.pants.ChainlockLeatherBikerPants.itemName}
      name={SS23.pants.ChainlockLeatherBikerPants.itemName}
      price={SS23.pants.ChainlockLeatherBikerPants.itemPrice}
      fabric={SS23.pants.ChainlockLeatherBikerPants.itemFabric}
      src={SS23.pants.ChainlockLeatherBikerPants.sizeChart}
      divId={SS23.pants.ChainlockLeatherBikerPants.shopifyDivId}
      mainId={SS23.pants.ChainlockLeatherBikerPants.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        SS23.pants.ChainlockLeatherBikerPants.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={SS23.pants.ChainlockLeatherBikerPants.itemName}
              width={SS23.imgWidth}
              height={SS23.imgHeight}
              loading={SS23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default ChainlockLeatherBikerPants;
